import React, { useState } from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Dados do carrossel a partir do JSON
  const carrosselImagens = definicoescliente.Hero.CarrosselImagens || [];

  // Função para ir para a próxima imagem
  const proximaImagem = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % carrosselImagens.length);
  };

  // Função para ir para a imagem anterior
  const anteriorImagem = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? carrosselImagens.length - 1 : prevIndex - 1
    );
  };

  // Dados da imagem atual
  const imagemAtual = carrosselImagens[currentIndex] || {
    CarrosselImagem: '/images/modelo5hero.jpg',
    CarrosselTitulo: 'Proteção Veicular',
    CarrosselDescricao: 'Garanta a segurança do seu veículo com nossa assistência e planos personalizados. Confie em quem entende de proteção!',
    CarrosselNomeBotao: 'Seja um Associado',
    CarrosselLinkBotao: 'https://app.hinovamobile.com.br/AppConnectLead/AdesaoOnline/Index?codigoSegurancaAssociacao=MTk1MTE4MDQyMDIzMDgyMTU2',
  };

  return (
    <div
      className="relative mx-auto px-5 overflow-x-hidden lg:overflow-x-visible"
      style={{
        backgroundImage: `url(${imagemAtual.CarrosselImagem})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        height: '100vh',
        transition: 'background-image 0.5s ease-in-out',
      }}>
      {/* Conteúdo do Hero */}
      <div className="absolute inset-0 bg-theme-primary opacity-20"></div>
      <section className="relative grid items-center h-full px-14">
        <div className="order-2 lg:order-none mt-20">
          <h1 className="text-3xl xl:text-5xl font-bold font-theme-heading text-theme-white text-center lg:text-center">
            {imagemAtual.CarrosselTitulo}
          </h1>
          <p className="lg:text-lg mt-10 font-theme-content text-theme-white text-center lg:text-center max-w-lg mx-auto">
            {imagemAtual.CarrosselDescricao}
          </p>
          <div className="flex justify-center lg:justify-center mt-10">
            <div className="uppercase text-textopadrao bg-theme-secondary px-6 py-2 text-theme-light-secondary rounded shadow-md hover:theme-white border-2 border-transparent hover:border-theme-white hover:text-theme-white cursor-pointer transition duration-200">
              <a
                href={imagemAtual.CarrosselLinkBotao}
                target="_blank"
                rel="noopener noreferrer">
                {imagemAtual.CarrosselNomeBotao}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Ícones de navegação */}
      <div className="absolute top-1/2 left-0 transform -translate-y-1/2">
        <button onClick={anteriorImagem} className="transition duration-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            className="bi bi-chevron-left text-theme-white hover:text-theme-secondary transition duration-200 cursor-pointer"
            viewBox="0 0 16 16">
            <path
              fillRule="evenodd"
              d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
          </svg>
        </button>
      </div>
      <div className="absolute top-1/2 right-0 transform -translate-y-1/2">
        <button onClick={proximaImagem} className="transition duration-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            fill="currentColor"
            className="bi bi-chevron-right text-theme-white hover:text-theme-secondary transition duration-200 cursor-pointer"
            viewBox="0 0 16 16">
            <path
              fillRule="evenodd"
              d="M4.646 14.354a.5.5 0 0 1 0-.708L10.293 8 4.646 2.354a.5.5 0 1 1 .708-.708l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708 0z"/>
          </svg>
        </button>
      </div>
    </div>
  );
};

export default Hero;
